<template>
  <div class="new-order__main">
    <Loader v-if="isLoading" />
    <div class="container">
      <div class="new-order__main-title">Choose Payment Method</div>
      <div v-if="!cards.length" class="new-order__part">
        <div class="new-order__payment-title">
          Please add at least one payment method to proceed. You can have your personal or business payment option
          depending on the order type.
        </div>
        <div class="new-order__button" @click="showNewCard">
          <i class="ri-add-circle-fill"></i>
          <span class="new-order__button-text">Add New Payment Method</span>
        </div>
      </div>
      <div v-if="cards.length > 1" class="new-order__payment-title">
        Tap another card to change your payment method.
      </div>
      <Card v-for="card of cards" :key="card.id" :card="card" />
      <div v-if="cards.length && !NewCardShow" class="new-order__button" @click="showNewCard">
        <i class="ri-add-circle-fill"></i>
        <span class="new-order__button-text">Add New Payment Method</span>
      </div>
      <NewCard v-if="NewCardShow" />
    </div>
  </div>
</template>

<script>
import NewCard from './NewCard'
import Card from './Card'
import {mapState} from 'vuex'
import Loader from '@/components/Loader'

export default {
  name: 'PublicNewOrderNewCard',
  components: {NewCard, Card, Loader},
  props: {
    isLoading: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      NewCardShow: false
    }
  },
  computed: {
    ...mapState({
      cards: s => s.card.cards,
      activeCard: s => s.card.activeCard
    })
  },
  watch: {
    activeCard(card) {
      // activate(null) now stores {} (not null) as "no selection", so a bare
      // truthiness check here closed the new-card form the moment showNewCard
      // deselected cards. Only a real selection should close it.
      if (card && card.active) this.NewCardShow = false
    },
    cards() {
      this.NewCardShow = false
      this.autoSelectFirstCard()
    }
  },
  async created() {
    if (!this.cards.length) {
      try {
        await this.$store.dispatch('card/fetch')
      } catch (e) {
        // Message surfaced by the layout's error watcher; the empty-state
        // "add a payment method" UI is the right fallback here.
        return
      }
    }
    this.autoSelectFirstCard()
  },
  methods: {
    // Preselect a card so Pay is never grey on arrival. #19 did this only for a
    // single card, on the theory that with several we should make the customer
    // choose rather than guess. Watching a real session (Brett, 2026-09-22)
    // settled it the other way: a customer with two cards saw two grey
    // checkboxes, read the grey Pay button as "payment is broken", and never
    // tapped a card. Defaulting to the first and telling them they can change
    // it matches every checkout they already use.
    autoSelectFirstCard() {
      if (!this.cards.length || (this.activeCard && this.activeCard.active)) return
      // The list comes back unordered and can contain expired cards, so take
      // the first one that is still valid — defaulting to a dead card would
      // trade a grey button for a Stripe decline. If they all look expired we
      // still select one, so Pay is reachable and the decline message explains
      // itself.
      const now = new Date()
      const year = now.getFullYear()
      const month = now.getMonth() + 1
      const usable = this.cards.find(c => {
        if (!c.expYear || !c.expMonth) return true
        return c.expYear > year || (c.expYear === year && c.expMonth >= month)
      })
      this.$store.commit('card/activate', usable || this.cards[0])
    },
    showNewCard() {
      this.$store.commit('card/activate', null)
      this.NewCardShow = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'style';
</style>
